export default "__VITE_ASSET__DKPin1uE__"